/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import IndexedDb from 'services/user-store/indexed-db';
import LocalStorage from 'services/user-store/local-storage';
import ObjectStore from 'services/user-store/object-store';

let userStoreProvider;

if (IndexedDb.browserSupported()) {
  userStoreProvider = new IndexedDb();
} else if (LocalStorage.browserSupported()) {
  userStoreProvider = new LocalStorage();
} else {
  userStoreProvider = new ObjectStore();
}

export default userStoreProvider;